import { motion } from "framer-motion";
import { Hexagon, ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { scrollToId } from "@/lib/scroll";

const Navbar = ({ onQuote }) => {
  const { lang, setLang, t } = useLanguage();

  const links = [
    { id: "servicios", label: t.nav.services },
    { id: "necesidades", label: t.nav.needs },
    { id: "modular", label: t.nav.modular },
    { id: "proceso", label: t.nav.process },
  ];

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-0 z-50 border-b border-cy/10 bg-ink/70 backdrop-blur-xl"
    >
      <nav className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-12">
        <button
          data-testid="nav-brand-logo"
          onClick={() => scrollToId("inicio")}
          className="group flex items-center gap-3"
        >
          <span className="relative grid h-9 w-9 place-items-center">
            <Hexagon className="h-9 w-9 text-cy transition-transform duration-500 group-hover:rotate-90" strokeWidth={1.4} />
            <span className="absolute font-display text-xs font-extrabold text-ink">Q</span>
          </span>
          <span className="flex flex-col items-start leading-none">
            <span className="font-display text-sm font-bold tracking-[0.18em] text-slate-100">QUANTUM</span>
            <span className="font-mono text-[10px] tracking-[0.34em] text-cy">CENTURY</span>
          </span>
        </button>

        <div className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="font-mono text-xs uppercase tracking-[0.18em] text-slate-400 transition-colors duration-300 hover:text-cy"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3 sm:gap-5">
          <div className="flex items-center rounded-full border border-cy/20 p-1" data-testid="language-toggle">
            {["es", "en"].map((code) => (
              <button
                key={code}
                data-testid={`language-toggle-${code}`}
                onClick={() => setLang(code)}
                className={`rounded-full px-3 py-1 font-mono text-[11px] uppercase tracking-widest transition-all duration-300 ${
                  lang === code ? "bg-cy text-ink font-bold" : "text-slate-400 hover:text-slate-200"
                }`}
              >
                {code}
              </button>
            ))}
          </div>
          <button
            data-testid="nav-quote-btn"
            onClick={onQuote}
            className="group hidden items-center gap-2 rounded-full bg-cy px-5 py-2.5 font-display text-sm font-bold text-ink transition-all duration-300 hover:bg-em hover:shadow-[0_0_25px_rgba(0,240,255,0.35)] sm:flex"
          >
            {t.nav.quote}
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </nav>
    </motion.header>
  );
};

export default Navbar;
